export enum ModuleType {
  CATALOG = 'CATALOG',
  CHECKOUT = 'CHECKOUT',
  USER = 'USER',
  ORDER = 'ORDER',
  NPS = 'NPS',
}
